export default __webpack_public_path__ + "static/media/slide_12.0802d9c5.jpg";